import { DEFAULT_CHILD_MAX_AGE_YEARS } from "../utils/guestSlotAgeValidation";

/** Set from {@link initializeTenant}; undefined until first chain-info load. */
let configuredChildMaxAgeYears: number | null | undefined;

export function setChildMaxAgeYears(years: number | null | undefined): void {
    configuredChildMaxAgeYears = years;
}

/**
 * Inclusive max age at arrival for CHILD slots. null = disabled.
 * When chain-info has not loaded yet, defaults to 17 (legacy under-18).
 */
export function getChildMaxAgeYears(): number | null {
    if (configuredChildMaxAgeYears === undefined) {
        return DEFAULT_CHILD_MAX_AGE_YEARS;
    }
    return configuredChildMaxAgeYears;
}
